import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';
@Injectable()
export class PotService {

    constructor(private apiService: ApiService) { }

    fetchByUser(id: number, params: DataTableParams): Observable<any> {
        params.offset = params.offset / params.limit;
        return this.apiService.post('/gandadmin/cagnottes/user/' + id, params)
    }
}
